// AUTO-GENERATED from Vendor_Package_Tag_Taxonomy.xlsx + Catering_Package_Inclusion_Exclusion_Tags.xlsx
// Curated package inclusion/exclusion tag library, grouped by category per service type.
// Shape: { [serviceType]: { includes: { [category]: string[] }, excludes: { [category]: string[] } } }
// Used for (1) quick-add suggestion chips in the package editor and
//          (2) grounding the AI so it draws includes/excludes from real production tags.

const PACKAGE_TAXONOMY = {
  "caterers": {
    "includes": {
      "Cuisine — Indian Regional": [
        "North Indian",
        "South Indian",
        "Gujarati",
        "Rajasthani",
        "Punjabi",
        "Bengali",
        "Mughlai",
        "Maharashtrian"
      ],
      "Cuisine — International / Fusion": [
        "Chinese",
        "Italian",
        "Mexican",
        "Thai",
        "Continental",
        "Lebanese / Mediterranean",
        "Pan-Asian",
        "Fusion / Modern Indian"
      ],
      "Live Counters": [
        "Chaat Counter",
        "Pani Puri Counter",
        "Dosa Counter",
        "BBQ / Grill Counter",
        "Tandoor Live Counter",
        "Ice Cream / Dessert Counter",
        "Pasta Counter",
        "Chinese Wok Counter",
        "Mocktail / Live Juice Counter"
      ],
      "Beverages": [
        "Welcome Drinks",
        "Mocktails",
        "Fresh Juice Bar",
        "Tea / Coffee Station",
        "Soft Drinks Unlimited"
      ],
      "Service Style": [
        "Buffet Service",
        "Plated / Sit-down Service",
        "On-site Chef",
        "Family Style Service",
        "Live Cooking Stations"
      ],
      "Dietary & Special Requests": [
        "Jain Food Available",
        "Vegan Options",
        "No Onion No Garlic",
        "Halal Certified",
        "Gluten-Free Options"
      ],
      "Desserts": [
        "Indian Sweets Counter",
        "Live Dessert Station",
        "Paan Counter"
      ],
      "Staffing & Equipment": [
        "Waitstaff Included",
        "On-site Chef",
        "Crockery & Cutlery Included",
        "Table Linen Included",
        "Uniformed Serving Staff"
      ]
    },
    "excludes": {
      "Common": [
        "non-veg options",
        "vegetarian options",
        "customized menus",
        "Alcohol Service",
        "Outside Venue Catering"
      ],
      "Dietary Exclusions": [
        "Non-Veg Options",
        "Vegetarian Options",
        "Jain Food",
        "Alcohol Service"
      ],
      "Customization Limits": [
        "Customized Menus",
        "Menu Substitutions",
        "Additional Live Counters"
      ],
      "Logistics Exclusions": [
        "Outside Venue Catering",
        "Delivery Beyond Service Radius",
        "Table & Seating Arrangement",
        "Decor for Food Counters"
      ],
      "Service Exclusions": [
        "Waitstaff",
        "Crockery & Cutlery",
        "Overtime / Extended Hours"
      ]
    }
  },
  "venue": {
    "includes": {
      "Amenities": [
        "parking",
        "valet_parking",
        "bar_counter",
        "green_room",
        "ac_banquet_hall",
        "open_lawn",
        "rooftop_terrace",
        "power_backup",
        "wheelchair_accessible"
      ],
      "Accommodation": [
        "5_star_hotel",
        "4_star_hotel",
        "guest_rooms_included",
        "complimentary_couple_suite"
      ],
      "Capacity & Setup": [
        "stage_setup",
        "dance_floor",
        "led_screen_projector",
        "round_table_seating"
      ],
      "Bundled Services": [
        "catering_services",
        "in_house_decor",
        "event_planning",
        "dj_entertainment",
        "security_staff"
      ]
    },
    "excludes": {
      "Common": [
        "catering services",
        "decorations",
        "premium catering",
        "entertainment services",
        "personalized event planning",
        "high-end decor",
        "alcohol_license"
      ]
    }
  },
  "decors": {
    "includes": {
      "Decor Style": [
        "basic decor elements",
        "enhanced decor options",
        "thematic styling",
        "luxurious decor",
        "personalized styling",
        "minimalist decor",
        "traditional decor",
        "destination decor"
      ],
      "Floral": [
        "basic floral arrangements",
        "custom floral arrangements",
        "fresh flower backdrop",
        "artificial flower decor"
      ],
      "Lighting": [
        "basic lighting",
        "advanced lighting",
        "fairy_lights",
        "led_wall"
      ],
      "Furniture & Structures": [
        "premium furniture",
        "mandap_stage_setup",
        "entrance_gate_decor",
        "photo_booth_backdrop"
      ],
      "Add-ons": [
        "live entertainment",
        "fireworks_pyrotechnics",
        "draping_fabric_work"
      ]
    },
    "excludes": {
      "Common": [
        "advanced lighting",
        "custom floral arrangements",
        "premium furniture",
        "live entertainment",
        "destination decor",
        "catering services"
      ]
    }
  },
  "photography": {
    "includes": {
      "Core Services": [
        "candid_photography",
        "traditional_photography",
        "cinematic_video",
        "same_day_edit",
        "pre_wedding_shoot"
      ],
      "Add-on Technology": [
        "drone_services",
        "photo_booth",
        "virtual_reality",
        "live_streaming",
        "360_camera_booth"
      ],
      "Deliverables": [
        "printed_album",
        "digital_album",
        "online_gallery",
        "usb_hard_drive_delivery"
      ],
      "Team & Coverage": [
        "second_shooter",
        "multi_day_coverage",
        "multiple_camera_crew"
      ]
    },
    "excludes": {
      "Common": [
        "photo_booth",
        "cinematic_video",
        "virtual_reality",
        "live_streaming",
        "drone_services"
      ]
    }
  }
};

/** All include tags for a service type as a flat, de-duped list. */
export function flatIncludes(serviceType) {
  const t = PACKAGE_TAXONOMY[serviceType];
  return t ? Object.values(t.includes).flat() : [];
}

/** All exclude tags for a service type as a flat, de-duped list. */
export function flatExcludes(serviceType) {
  const t = PACKAGE_TAXONOMY[serviceType];
  return t ? Object.values(t.excludes).flat() : [];
}

/** Grouped includes { category: [tags] } for chip rendering. */
export function includeGroups(serviceType) {
  return PACKAGE_TAXONOMY[serviceType]?.includes || {};
}

/** Grouped excludes { category: [tags] } for chip rendering. */
export function excludeGroups(serviceType) {
  return PACKAGE_TAXONOMY[serviceType]?.excludes || {};
}

export default PACKAGE_TAXONOMY;
